import React, { useState, useEffect } from "react";

import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";
import { NavLink } from "react-router-dom";
import MUIDataTable from "mui-datatables";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

//Material UI Icons
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  FormHelperText,
  NativeSelect,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  // Grid,
  // Select,
  Input,
  InputLabel,
  // MenuItem,
  Modal,
  Backdrop,
  //Fade,
  fade,
  Button,
  Grid,
  Breadcrumbs,
  Typography,
  Fade,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone, FaceRounded } from "@material-ui/icons";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MessageBox from "../../../components/MessageBox/MessageBox";
const useStyles = makeStyles((theme) => ({
  // modal: {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  // },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",

    margin: "0 auto",
  },
  textField: {
    marginTop: "-15px",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "400px",
    maxHeight: "100%",
    overflow: "auto",
  },
}));

const UpdateSupplier = (props) => {
  const { showModal, supplier_id } = props;
  const [posts, setPosts] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(true);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 7),
  });
  const [filterType, setFilterType] = useState("1");
  const [supplierName, setSupplierName] = useState("");
  const [address, setAddress] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [otherInfo, setOtherInfo] = useState("");
  const [idno, setIdno] = useState("");
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [branchIdData, setBranchIdData] = useState([]);
  const [creditData, setCreditData] = useState([]);
  const [branchidno, setBranchidno] = useState("");
  const [supplierData, setSupplierData] = useState("");
  const [credit, setCredit] = useState();
  const classes = useStyles();

  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("empty");
  const [btnAddDisabled, setBtnAddDisabled] = useState(false);
  const [msgType, setMsgType] = useState("success");
  const [displayView, setDisplayView] = useState(false);

  const getCreditData = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "get_credit")
      .then(function (res) {

        setCreditData(res.data.data);
      })
      .catch(function (error) {
        // console.log(error);
      });
  };
  const selectBranchIdProps = {
    options: branchIdData,
    getOptionLabel: (option) => option.idno,
  };
  const selectCreditProps = {
    options: creditData,
    getOptionLabel: (option) => option.description,
  };

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const getSupplier = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "get_single_supplier", {
        params: {
          supplier_id: supplier_id,
        },
      })
      .then(function (res) {

        setSupplierData(res.data[0]);
        setSupplierName(res.data[0].suppliername);
        setAddress(res.data[0].address);
        setContactNo(res.data[0].contactno);
        setContactPerson(res.data[0].contactperson);
        setBranchidno(res.data[0].branchidno);
        setCredit(res.data[0].credit);
        setOtherInfo(res.data[0].otherinf);
      })
      .catch(function (error) {
        // console.log(error);
      });
  };
  const updateSupplier = async () => {
    await axios
      .post(process.env.REACT_APP_API_URL + "update_supplier", {
        suppliername: supplierName,
        id: supplier_id,
        contactno: contactNo,
        contactperson: contactPerson,
        credit: credit,
        otherinfo: otherInfo,
        address: address,
      })
      .then(function (res) {
        showModal('Supplier Updated','success');
        handleModalClose();
        // setUserRoleData(res.data.data.position);
        // setCanApprove(res.data.data.position.can_approve.toString());
        // setCanEdit(res.data.data.position.can_edit.toString());
        // setCanDelete(res.data.data.position.can_delete.toString());
        // setCanProcess(res.data.data.position.can_process.toString());
        // setLoading(true);
      })
      .catch(function (error) {
        showModal('Something went wrong'+error,'success');
        // console.log(error);
      });
  };

  useEffect(() => {
    //
    getSupplier();
    getCreditData();
  }, []);
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={handleModalOpen}
        style={{ backgroundColor: "#4caf50", color: "#fff", marginRight: 10 }}
      >
        Edit
      </Button>
      <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={modalOpen}
          onClose={handleModalClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <div className={classes.paper}>
            <h2 id="transition-modal-title">Update Supplier</h2>
            <form action="" className={classes.root}>
              <div>
                <TextField
                  id="outlined-full-width"
                  label="Supplier Name"
                  value={supplierName}
                  style={{ margin: 8 }}
                  placeholder="Enter Supplier Name"
                  fullWidth
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  onChange={(e) => {
                    setSupplierName(e.target.value);
                  }}
                />
              </div>
              <div>
                <TextField
                  id="outlined-full-width"
                  label="Address"
                  style={{ margin: 8 }}
                  placeholder="Enter Address"
                  value={address}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  onChange={(e) => {
                    setAddress(e.target.value);
                  }}
                />
              </div>
              <div>
                <TextField
                  id="outlined-full-width"
                  value={contactNo}
                  label="Contact Number"
                  style={{ margin: 8 }}
                  placeholder="Enter Contact Number"
                  fullWidth
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  onChange={(e) => {
                    setContactNo(e.target.value);
                  }}
                />
              </div>
              <div>
                <TextField
                  id="outlined-full-width"
                  label="Contact Person"
                  value={contactPerson}
                  style={{ margin: 8 }}
                  placeholder="Enter Contact Person"
                  fullWidth
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  onChange={(e) => {
                    setContactPerson(e.target.value);
                  }}
                />
              </div>

              <div style={{ marginLeft: 8, width: "100%" }}>

                {/* <TextField id="outlined-basic" label="Branch Id No" variant="outlined" placeholder="Branch Id No" inputProps={{ 'aria-label': 'User Name' }} value={branchidno} onChange={e => setBranchidno(e.target.value)}/> */}
                <Autocomplete
                  {...selectCreditProps}
                  id="auto-complete"
                  autoComplete
                  includeInputInList
                  defaultValue={creditData[credit - 1]}
                  className={classes.autoComplete}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Credit"
                      margin="normal"
                      variant="outlined"
                    />
                  )}
                  onChange={(event, newValue) => {
                    if (!newValue == "" || !newValue == null) {
                      setCredit(newValue.id);
                    } else {
                      setCredit(null);
                    }
                  }}
                />
              </div>
              <div>
                <Grid item>
                  <TextField
                    id="outlined-full-width"
                    label="Other Info"
                    style={{ margin: 8 }}
                    placeholder="Enter additional info"
                    fullWidth
                    value={otherInfo}
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    onChange={(e) => {
                      setOtherInfo(e.target.value);
                    }}
                  />
                </Grid>
              </div>

              <div className={classes.button}>
                <Grid container spacing={2} justifyContent="space-between" style={{paddingRight:50}}>
                  <Grid item xs={12} sm={2}>
                    <Button
                      variant="contained"
                      onClick={handleModalClose}
                   
                    >
                      Close
                    </Button>
                  </Grid>
     
                  <Grid item xs={12} sm={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        updateSupplier();
                      }}
                    >
                      Update
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </form>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default UpdateSupplier;
